
import type { PropType } from 'vue'
import { defineComponent, reactive } from 'vue'

import type { TtnDirection } from '@/new-services/types/tms'

export default defineComponent({
    props: {
        direction: {
            type: Object as PropType<TtnDirection>,
            required: true,
        },
        viewKey: {
            type: String,
            default: 'sector',
        },
    },
    setup() {
        const state = reactive({
            is_opened: false,
        })

        const toggle = () => {
            state.is_opened = !state.is_opened
        }

        return {
            state,
            toggle,
        }
    },
})
